// extracted by mini-css-extract-plugin
export default {"pageHeader":"OrderInfoContainer_pageHeader__uavsU","customPayBtn":"OrderInfoContainer_customPayBtn__RuxR8","btnContainer":"OrderInfoContainer_btnContainer__qk55S"};